import type { CSSProperties } from "react";

// The five category hues, in the order the hash indexes them.
const CATEGORY_HUES = [
    "var(--wai-agent-category-1)",
    "var(--wai-agent-category-2)",
    "var(--wai-agent-category-3)",
    "var(--wai-agent-category-4)",
    "var(--wai-agent-category-5)"
] as const;

// FNV-1a, so a category takes the same hue here as in wl-app.
function hashCategoryId(id: string): number {
    let hash = 2166136261;
    for (let i = 0; i < id.length; i++) {
        hash ^= id.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
    }

    return hash >>> 0;
}

function goodVibeCategoryHue(categoryId: string | null): string | null {
    if (categoryId === null || categoryId === "") {
        return null;
    }

    return CATEGORY_HUES[hashCategoryId(categoryId) % CATEGORY_HUES.length] ?? null;
}

export interface GoodVibeSurfaceProps {
    className: string;
    style?: CSSProperties;
}

export function goodVibeSurfaceProps(categoryId: string | null): GoodVibeSurfaceProps {
    const hue = goodVibeCategoryHue(categoryId);

    return hue === null
        ? { className: "wai-gv-surface" }
        : { className: "wai-gv-surface wai-gv-surface-tinted", style: { "--wai-gv-hue": hue } as CSSProperties };
}
